import styled from "styled-components"
import { Headline } from "../../../utils"

export const Wrapper = styled.div`
  background: ${(props) => props.theme.bgSectorColor};
`
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  max-width: 1500px;
  width: 100%;
  background: transparent;
  @media only screen and (max-width: 1375px) {
    display: flex;
    flex-direction: column;
    padding: 60px 0px 60px 0px;
  }
  @media only screen and (max-width: 500px) {
    padding: 40px 0px 40px 0px;
  }
`
export const HeadlineText = styled(Headline)`
  margin-bottom: 0px;
  text-align: start;
`
export const TechDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 100px;

  @media only screen and (max-width: 1375px) {
    display: flex;
    margin: auto;
    padding-left: 0px;
  }

  @media only screen and (max-width: 768px) {
    padding: 0 20px;
  }

  span {
    background: linear-gradient(to right, #0058ee, #36d7b7cc);
    /* stylelint-disable property-no-vendor-prefix */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .info {
    ${(props) => props.theme.typography.paragraphInfo};
    color: ${(props) => props.theme.whiteAlpha60};
    text-align: justify;
    max-width: 664px;
    margin-top: 16px;
    line-height: 170%;

    @media only screen and (max-width: 500px) {
      font-size: 0.875rem;
      margin-top: 12px;
    }
  }
`

export const CompanyIconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 60px;

  @media only screen and (max-width: 500px) {
    margin-top: 20px;
  }

  .divider {
    background: ${(props) => props.theme.gray18};
    width: 100%;
    width: 1px;
    height: auto;
    margin: 0 60px;

    @media only screen and (max-width: 500px) {
      height: 40px;
      display: flex;
      align-self: center;
      margin: 0 30px;
    }
  }

  .company-icons {
    display: flex;
  }
`

export const ImagesContainer = styled.div`
  max-width: 1500px;

  img {
    width: 100%;
    height: auto;
  }

  @media only screen and (max-width: 1375px) {
    margin-top: 35px;
  }

  @media only screen and (max-width: 500px) {
    margin-top: 20px;
  }
`

export const LargeScreenImages = styled.div`
  @media only screen and (max-width: 1375px) {
    display: none;
  }

  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;

  .column {
    flex: 100%;
    max-width: 310px;
    padding-left: 16px;
    display: flex;
    flex-direction: column;
  }

  .column img {
    vertical-align: middle;
    width: 100%;
    height: auto;
    flex: 1;
    object-fit: cover;
  }

  .column img:not(:last-child) {
    margin-bottom: 15.3px;
  }

  #long-img {
    height: 100%;
  }
`

export const SmallScreenImages = styled.div`
  @media only screen and (min-width: 1375px) {
    display: none;
  }

  @media only screen and (max-width: 1375px) {
    display: flex;
    justify-content: center;
  }

  .row {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
    padding: 40px 40px 60px 40px;
    @media only screen and (max-width: 500px) {
      grid-gap: 12px;
      padding: 0px;
    }
  }

  .grid-item:nth-child(4) {
    grid-column: span 2;
  }
`
